export default {
  All: -1,
}
